import {HttpRequest,HttpMethod} from "./http";

class WmsProvider extends HttpRequest {
    StorageCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/storage`, params);
    }
    StorageUpdate(id,payload) {
        return this.request(HttpMethod.Put,`/api/v1/wms/storage/${id}`, payload);
    }
    StorageDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/storage/${id}` );
    }
    StorageList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/storage`, params);
    }

    PartnerCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/partner`, params);
    }
    PartnerUpdate(id,payload ) {
        return this.request(HttpMethod.Put,`/api/v1/wms/partner/${id}` , payload);
    }
    PartnerDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/partner/${id}` );
    }
    PartnerList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/partner`, params);
    }

    ProductCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/product`, params);
    }
    ProductUpdate(id,payload) {
        return this.request(HttpMethod.Put,`/api/v2/wms/product/${id}` , payload);
    }
    ProductDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/product/${id}` );
    }
    // params.active = "1" | "0" | "all" (bo-api #834 B2; BE default "1" = active only)
    ProductList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/product`, params);
    }
    // bo-api #834 B3: POST {is_active: 0|1} -> row + stock_balance. POST, not PUT:
    // an older BE routes PUT /wms/product/:id/* to the product-update handler and
    // blanks the product; for POST it answers 404/405 and changes nothing.
    ProductSetActive(id, payload) {
        return this.request(HttpMethod.Post,`/api/v1/wms/product/${id}/active`, payload);
    }
	ProductGetBarcode(params) {
        return this.request(HttpMethod.Get,`/api/v1/util/barcode`, params);
    }

    InventoryList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory`, params);
    }
    InventoryHistory(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/inventory/history`, params);
    }
    InventoryHistoryDetail(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/historydetail/` + params);
    }
	InventoryListByStorage(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/history/linepack`, params);
	}
	InventoryListByStorageV2(params) {
        return this.request(HttpMethod.Get,`/api/v2/wms/inventory/history/linepack`, params);
	}
    // InventoryIn(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/in`, params);
    // }
    // InventoryOut(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/out`, params);
    // }
    // InventoryTransfer(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/group/move`, params);
    // }
	InventoryIn(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/in`, params);
    }
    InventoryOut(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/out`, params);
    }
    InventoryTransfer(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/group/move`, params);
    }
    InventoryTransferByUser(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/inventory/user/move`, params);
    }
    InventoryMoveReturnToRetail(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/return/move-to-retail`, params);
    }
    // Current balance of the whole return warehouse, resolved server-side.
    // Deliberately NOT InventoryList(): that pulls the entire wms_inventory
    // table and guesses the return storage id from its name on the client.
    InventoryReturnBalance(params) {
        return this.request(HttpMethod.Get,`/api/v2/wms/inventory/return/balance`, params);
    }
    InventoryMoveReturnToMain(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/return/move-to-main`, params);
    }
    InventoryDelete(params) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/inventory/${params}` );
    }

    PromotionCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/profile/pickup/create`, params);
    }
    PromotionDelete(params) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/profile/pickup/${params}`);
    }
    PromotionList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/profile/pickup`, params);
    }

	ProductWaitShipList(params) {
        return this.request(HttpMethod.Get,`/api/v1/orders/product/wait/shipment`, params);
    }

	WmsInventorySummary(params){
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/summary`,params );
	}

	WmsInventorySummaryV2(params){
        return this.request(HttpMethod.Get,`/api/v2/wms/inventory/summary`,params );
	}

	// Stock Sync V3 APIs
	ProductListV3(params) {
		return this.request(HttpMethod.Get,`/api/v3/wms/product`, params);
	}

	// Lightweight dropdown source: { items: [{id, name, man_pn, barcode}] },
	// only rows with a man_pn, limit 1000, ?search= on name/man_pn/barcode.
	// Any authenticated role. Use THIS for pickers — ProductListV3 above
	// walks the whole inventory + every open order and never returns on
	// production data (mdf-bo-fn#246 follow-up; same lesson as Modern Trade).
	ProductOptions(params) {
		return this.request(HttpMethod.Get,`/api/v3/wms/product-options`, params);
	}

	ProductStockSyncToggle(id, params) {
		return this.request(HttpMethod.Patch,`/api/v3/wms/product/${id}/stock-sync`, params);
	}

	ProductStockAlarmToggle(id, params) {
		return this.request(HttpMethod.Patch,`/api/v3/wms/product/${id}/stock-alarm`, params);
	}

	ProductStockSettings(id, params) {
		return this.request(HttpMethod.Patch,`/api/v3/wms/product/${id}/stock-settings`, params);
	}

	// Stock Forecast
	ProductForecast(params) {
		return this.request(HttpMethod.Get,`/api/v3/wms/product/forecast`, params);
	}

	// Stock Usage — usage per product over a custom date range (max 31 days).
	ProductUsage(params) {
		return this.request(HttpMethod.Get,`/api/v3/wms/product/usage`, params);
	}

	// #437 shipped without stock deduction (spec 2026-10-09 §4). GET returns
	// every order row (cap 5,000); the page filters/aggregates client-side.
	// #439 (§8): the ack/undo endpoints still exist on the BE but the FE no
	// longer calls them (owner dropped manual stock marking).
	getShippedNoDeduct(params) {
		return this.request(HttpMethod.Get,`/api/v2/wms/report/shipped-no-deduct`, params);
	}

}

export default WmsProvider;
